import { AxiosResponse } from 'axios';
import { StampCertificateForm } from 'civil-status/components/stamp-certificate/form';
import { HttpResponse } from 'shell/models/http-response';
import { StampCertificate } from 'shell/models/stamp-certificate';

export const transformResponseStampCertificate = (
  response: AxiosResponse<HttpResponse<StampCertificate>>
): StampCertificateForm => {
  const responseData = response.data.payload;
  return {
    code: responseData.key?.codiceTesto,
    printElement: responseData.tipoElemento,
    text: responseData.testoStampa,
    type: responseData.tipoStampa,
    typeAct: responseData.tipoAtto,
    editor: responseData.codiceModificatore,
  };
};
